import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=67ed44dd"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67ed44dd')) {
      api.createRecord('67ed44dd', component.options)
    } else {
      api.reload('67ed44dd', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=67ed44dd", function () {
      api.rerender('67ed44dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vendor/firegroup/fire-core-formgenerator/src/assets/vue/frontend/Form.vue"
export default component.exports